<template>
  <div v-if="!showTag">
    <el-tabs  v-model="tabNames"  >
      <el-tab-pane
        v-for="(listElemT,listIndex) in tabList"
        :key="listIndex"
        :label="listElemT.tagName"
        :name="listElemT.tagName"
      >
        <p class="fileName">{{listElemT.fileList[0].filename}}分析结果文件</p>
        <table-detail :projectId="projectId" :analyzeId="analyzeId" :path="path" :passGroupSampleName="groupSampleName"
                      :folder="listElemT.fileList[0].folder" :fileName="listElemT.fileList[0].filename"
                      :key="listIndex"
                      @getTableLoading="getTableLoading"
        ></table-detail>
<!--        :key="listIndex+Math.random().toString(36).substring(2, 9)"-->
      </el-tab-pane>
    </el-tabs>
  </div>
  <div v-else>
    <el-tabs  v-model="tabNames" >
      <el-tab-pane :name="tabNames">
        <template v-slot:label >
          <div>
            <el-select v-model="tabNames" filterable placeholder="请选择" style="width: 280px"
                       @change="handleSelectedTag">
              <el-option
                v-for="(elemF, index) in tabList"
                :key="index"
                :label="elemF.tagName"
                :value="elemF.tagName">
              </el-option>
            </el-select>
          </div>
        </template>
        <p class="fileName">{{selectedTag.fileList[0].filename}}分析结果文件</p>
        <table-detail :projectId="projectId" :analyzeId="analyzeId" :path="path" :passGroupSampleName="groupSampleName"
                      :folder="selectedTag.fileList[0].folder" :fileName="selectedTag.fileList[0].filename"
                      :key="selectedTagIndex+Math.random().toString(36).substring(2, 9)"
                      @getTableLoading="getTableLoading"
        ></table-detail>
      </el-tab-pane>
    </el-tabs>
  </div>

</template>

<script>
import TableDetail from "@/components/TableDetail";

export default {
  name: "TaskDetailTabInner",
  components:{
    'table-detail':TableDetail
  },
  props:{
    projectId:'',
    analyzeId:'',
    path:'',
    tabName:'',
    tabList: {},
    index:'',
    showTag:Boolean,
    groupSampleName:{}
  },
  data(){
    return{
      tabNames:JSON.parse(JSON.stringify(this.tabName)),
      selectedTag:JSON.parse(JSON.stringify(this.tabList[0])),
      selectedTagIndex: 0,
    }
  },
  mounted() {
  },
  watch:{
    tabName(newValue, oldValue) {
      this.tabNames=newValue
    },
  },
  methods:{
    handleSelectedTag(value) {
      const index = this.getIndexSelectTag(value, this.tabList)
      this.selectedTag = this.tabList[index]
      this.selectedTagIndex = index
      this.tagNames = this.tabList[index].tagNames
    },
    getIndexSelectTag(value, obj) {
      const index = obj.findIndex(obj => obj.tagName === value)
      return index
    },
    getTableLoading(){
      this.$emit("getTableLoading")
    }

  }
}
</script>

<style lang="scss" scoped>
.fileName {
  /*list-style-type: disc;*/
  color: #1e6cb0;
  margin: 15px 0px;
}
::v-deep.el-tabs__nav  {
  background-color: yellow!important;
  width: 100%;
}
</style>
